export default function ({ redirect, i18n }) {
  if (i18n.locale === 'en') {
    return redirect('/')
  }
}
